import { useState, useEffect } from "react";
import AuthTokenProvider from "../services/AuthTokenProvider";

/**
 * Parses the roles[] claim from a JWT payload.
 * Uses the same atob technique as AuthTokenProvider._extractExp().
 */
const hasRole = (token, roleName) => {
    try {
        const payload = JSON.parse(
            atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
        );
        return (Array.isArray(payload?.roles) ? payload.roles : []).includes(roleName);
    } catch {
        return false;
    }
};

/**
 * useIsAdmin
 * ----------
 * Returns `true` if the currently signed-in user has the "SparkAnyWhereAdmin"
 * Azure AD app role in their Teams SSO token.
 *
 * Usage:
 *   const isAdmin = useIsAdmin();
 */
const useIsAdmin = () => {
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const token = await AuthTokenProvider.getAccessToken();
                if (!cancelled) setIsAdmin(hasRole(token, "SparkAnyWhereAdmin"));
            } catch {
                if (!cancelled) setIsAdmin(false);
            }
        })();
        return () => { cancelled = true; };
    }, []);

    return isAdmin;
};

export default useIsAdmin;